import { render, staticRenderFns } from "./content-webview.vue?vue&type=template&id=670c8cc8&scoped=true&"
import script from "./content-webview.vue?vue&type=script&lang=js&"
export * from "./content-webview.vue?vue&type=script&lang=js&"
import style0 from "./content-webview.vue?vue&type=style&index=0&id=670c8cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c8cc8",
  null
  
)

export default component.exports